import { curry } from 'ramda';

export const numberInRange = curry((min: number, max: number, number: number) => {
  return Math.max(min, Math.min(number, max));
});

export const numberIn0To100 = numberInRange(0, 100);

export const numberIn0To1 = numberInRange(0, 1);
